import { warn } from '@execonline-inc/logging';
import { assertNever } from '@kofno/piper';
import { Task } from 'taskarian';
import { AppyError, callApi } from '../Appy';
import { currentUserStore } from '../CurrentUserStore';
import ErrorActionableReaction, { EAProps, handleError } from '../ErrorActionableReaction';
import { MissingLinkError, findLinkT } from '../LinkyLinky';
import { Link } from '../Resource/Types';
import { reportsResourceDecoder } from './Decoders';
import { State } from './Types';
import ReportsStore from './index';

interface Props extends EAProps<ReportsStore> {}

type ReportsError = AppyError | MissingLinkError;

const handleReportsError = (store: ReportsStore) => (error: ReportsError) => {
  switch (error.kind) {
    case 'missing-link-error':
      store.error('Reports link is unavailable');
      warn('ReportsReactions', `Missing link: ${error.rel}`, error);
      break;
    default:
      handleError(store, error);
  }
};

const getReports = callApi(reportsResourceDecoder, {});

class ReportsReactions extends ErrorActionableReaction<ReportsStore, State, Props> {
  tester = () => this.props.store.state;
  effect = (state: State) => {
    const { store } = this.props;
    switch (state.kind) {
      case 'waiting':
        break;
      case 'loading':
        Task.succeed<ReportsError, ReadonlyArray<Link>>(currentUserStore.links)
          .andThen(findLinkT('reports'))
          .andThen(getReports)
          .fork(handleReportsError(store), store.ready);
        break;
      case 'ready':
      case 'error':
        break;
      default:
        assertNever(state);
    }
  };
}

export default ReportsReactions;
